export enum CmpConfigPropertiesCreationType {
    FLASH = "flash",
    ADVANCED = "advanced",
    DUPLICATE = "duplicate"
}
